import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { allGenres, allWorks } from "@/utils/catalog";

const hotTags = allGenres.slice(0, 12);

const ranking = [...allWorks]
  .sort((a, b) => b.popularity - a.popularity)
  .slice(0, 5);

export default function Sidebar() {
  return (
    <aside className="flex flex-col gap-5">
      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center rounded bg-accent-500 text-background-50">
            <i className="ri-apps-2-line text-xs"></i>
          </span>
          分类栏目
        </h2>
        <nav className="mt-3 flex flex-col gap-1">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/category/${c.id}`}
              className="flex items-center gap-2 rounded-md px-2 py-2 text-sm text-foreground-700 transition-colors hover:bg-primary-50 hover:text-primary-700 cursor-pointer"
            >
              <span className="flex h-5 w-5 items-center justify-center">
                <i className={c.icon}></i>
              </span>
              {c.name}
              <span className="ml-auto flex h-4 w-4 items-center justify-center text-foreground-400">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </Link>
          ))}
        </nav>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center rounded bg-secondary-500 text-background-50">
            <i className="ri-price-tag-3-line text-xs"></i>
          </span>
          热门标签
        </h2>
        <div className="mt-3 flex flex-wrap gap-2">
          {hotTags.map((tag) => (
            <Link
              key={tag}
              to={`/search?q=${encodeURIComponent(tag)}`}
              className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900 transition-colors hover:bg-secondary-200 cursor-pointer"
            >
              {tag}
            </Link>
          ))}
        </div>
      </div>

      <div className="rounded-lg border border-background-200 bg-background-50 p-4">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center rounded bg-primary-500 text-background-50">
            <i className="ri-bar-chart-2-line text-xs"></i>
          </span>
          热度榜
        </h2>
        <ol className="mt-3 flex flex-col gap-1">
          {ranking.map((w, i) => (
            <li key={w.id}>
              <Link
                to={`/detail/${w.id}`}
                className="flex items-center gap-3 rounded-md px-1 py-1.5 transition-colors hover:bg-background-100 cursor-pointer"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded text-xs font-bold ${
                    i === 0
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm text-foreground-800">{w.title}</span>
                  <span className="block text-[11px] text-foreground-500">
                    {w.rating.toFixed(1)} 分 · {w.year}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
}